import React from "react";
import { Button, Grid, Typography } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import paths from "@icarius-router/paths";
import { useSelector } from "react-redux";
import { getAvailablePaths, getDigitalDocumentsAmount } from "@icarius-app/selectors";
import {
    getMyPendingAmount,
    getMyRequestsAmount,
    getRequestedDocumentsAmount,
} from "@icarius-pages/myDesktop/selectors";
import { getLocalizedString } from "@icarius-localization/strings";

const CustomButton = ({ title, onClick, amount }) => {
    return (
        <Button
            onClick={onClick}
            variant="outlined"
            style={{ background: "var(--tertiaryBackgroundColor)" }}
            className="whiteText"
            fullWidth
        >
            <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <Typography className="whiteText" style={{ fontSize: 14, paddingRight: amount ? 10 : 0 }}>
                    {title}
                </Typography>
                {amount > 0 && (
                    <div style={{ height: 22, width: 22, borderRadius: "50%", backgroundColor: "var(--mainText)" }}>
                        <Typography style={{ fontSize: 14, fontWeight: 500, color: "var(--secondaryBackgroundColor)" }}>
                            {amount > 9 ? "+9" : amount}
                        </Typography>
                    </div>
                )}
            </div>
        </Button>
    );
};

const ThirdSection = (props) => {
    const {
        handleOpenMyCertificatesDialog,
        handleOpenMyReceiptsDialog,
        handleOpenMyDigitalDocumentsDialog,
        userRole,
    } = props;

    const history = useHistory();
    const digitalDocumentsQuantity = useSelector(getDigitalDocumentsAmount);
    const availablePaths = useSelector(getAvailablePaths);
    const myRequestsAmount = useSelector(getMyRequestsAmount);
    const myPendingAmount = useSelector(getMyPendingAmount);
    const requestedDocumentsAmount = useSelector(getRequestedDocumentsAmount);

    const dataByRole = {
        C: [
            {
                name: getLocalizedString("myCertificateTitle"),
                onClick: handleOpenMyCertificatesDialog,
                path: paths.myCertificates,
            },
            {
                name: getLocalizedString("myRequests"),
                onClick: () => history.push(paths.myRequests),
                amount: myRequestsAmount,
                path: paths.myRequests,
            },
            {
                name: getLocalizedString("digitalDocuments"),
                onClick: handleOpenMyDigitalDocumentsDialog,
                amount: digitalDocumentsQuantity,
                path: paths.digitalDocuments,
            },
            {
                name: getLocalizedString("myReceiptsTitle"),
                onClick: handleOpenMyReceiptsDialog,
                path: paths.myReceipts,
            },
        ],
        M: [
            {
                name: getLocalizedString("myPending"),
                onClick: () => history.push(paths.myPending),
                amount: myPendingAmount,
                path: paths.myPending,
            },
            {
                name: getLocalizedString("myRequests"),
                onClick: () => history.push(paths.myRequestsManager),
                amount: myRequestsAmount,
                path: paths.myRequestsManager,
            },
            {
                name: getLocalizedString("digitalDocuments"),
                onClick: handleOpenMyDigitalDocumentsDialog,
                amount: digitalDocumentsQuantity,
                path: paths.digitalDocuments,
            },
            {
                name: getLocalizedString("myPeopleTableTitle"),
                onClick: () => history.push(paths.myPeople),
                path: paths.myPeople,
            },
        ],
        E: [
            {
                name: getLocalizedString("myPending"),
                onClick: () => history.push(paths.myPendingEmployer),
                amount: myPendingAmount,
                path: paths.myPendingEmployer,
            },
            {
                name: getLocalizedString("requestedDocuments"),
                onClick: () => history.push(paths.requestedDocuments),
                amount: requestedDocumentsAmount,
                path: paths.requestedDocuments,
            },
            {
                name: getLocalizedString("employeeMaster"),
                onClick: () => history.push(paths.peopleMaster),
                path: paths.peopleMaster,
            },
            {
                name: getLocalizedString("myPeopleTableTitle"),
                onClick: () => history.push(paths.myPeople),
                path: paths.myPeople,
            },
        ],
    };

    const filteredData = dataByRole[userRole]?.filter((item) => availablePaths.includes(item.path));

    return (
        <Grid container style={{ paddingTop: 20 }}>
            {filteredData.map((item) => {
                return (
                    <Grid key={item.name} item xs={12} sm={6} md={3} style={{ padding: 5 }}>
                        <CustomButton title={item.name} onClick={item.onClick} amount={item.amount} />
                    </Grid>
                );
            })}
        </Grid>
    );
};

export default ThirdSection;
